module.exports = __webpack_public_path__ + "static/media/rch.b5aa2879.png";